import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-generic-error-dialog',
    templateUrl: './generic-error-dialog.html'
})
export class GenericErrorDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<GenericErrorDialogComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any) { }

    closeDialog(): void {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/dialogs/generic-error-dialog/generic-error-dialog.ts